import React from 'react';
import { connect } from 'react-redux';
import { LayerCreator } from '@leverege/ui-google-maps-elements';
import UserPositionAdapter from "./UserPositionAdapter.js";
import UserPosition from "../../shared/UserPosition.js";
import UserPositionModel from "../../shared/renderers/UserPositionModel.js";
class UserPositionRenderer extends React.Component {
  constructor(options) {
    super(options);
    const id = 'userPosition';
    this.adapter = new UserPositionAdapter();
    this.points = new LayerCreator({
      id,
      dataType: 'userPosition',
      adapter: this.adapter
    });
    this.state = {
      items: []
    };
  }
  componentDidUpdate(prevProps) {
    const {
      authorized,
      model
    } = this.props;
    const {
      authorized: pAuthorized,
      model: pModel
    } = prevProps;
    const isVisible = UserPositionModel.getVisible(model);
    const pIsVisible = UserPositionModel.getVisible(pModel);
    if (authorized !== pAuthorized || isVisible !== pIsVisible) {
      if (authorized === true && isVisible === true) {
        UserPosition.addListener('position', this.onPosition);
      } else {
        UserPosition.removeListener('position', this.onPosition);
      }
    }
  }
  componentDidMount() {
    const {
      authorized,
      model
    } = this.props;
    const isVisible = UserPositionModel.getVisible(model);
    if (authorized && isVisible) {
      UserPosition.addListener('position', this.onPosition);
    }
  }
  componentWillUnmount() {
    UserPosition.removeListener('position', this.onPosition);
  }
  onPosition = evt => {
    const {
      coords
    } = evt;
    this.setState({
      items: [coords]
    });
  };
  render() {
    const {
      symbols,
      model,
      order,
      authorized,
      ...extraData
    } = this.props;
    const {
      items
    } = this.state;
    const isVisible = model ? UserPositionModel.getVisible(model) : true;
    if (!authorized || !isVisible) {
      return [];
    }
    const opts = {
      ...extraData,
      symbols,
      model,
      order
    };
    return this.points.getLayers(items, opts);
  }
}
export default connect((state, props) => {
  const authorized = state.ui.position?.authorized;
  return {
    authorized
  };
})(UserPositionRenderer);